// use-platform-id.js
import { useCallback } from "react";
import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import { IPlatform } from "@/interfaces/platform.interfaces";

export const usePlatformId = () => {
  // Estado SWR para armazenar a lista de plataformas
  const { data: platforms, mutate: setPlatforms } = useSWR<IPlatform[]>(SWR_KEYS.platformsList);

  // Função para atualizar a lista de plataformas
  const updatePlatforms = useCallback(
    (newPlatforms: IPlatform[]) => {
      setPlatforms(newPlatforms, false);
    },
    [setPlatforms]
  );

  const getPlatformByIdentifier = useCallback(
    (identifier: string) => {
      const platform = platforms?.find((p) => p.name.toUpperCase() === identifier);

      return platform ? { id: platform.id, name: platform.name } : null;
    },
    [platforms]
  );

  return { platforms, updatePlatforms, getPlatformByIdentifier };
};
